function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "cls-1",
  d: "M22,174.81v-.31c0-31.74,24.28-56.64,57.27-56.64,22.25,0,36.57,9.34,46.22,22.56l-22.72,17.58c-6.22-7.63-13.38-12.76-23.81-12.76-15.25,0-25.99,13.07-25.99,28.94v.31c0,16.34,10.74,29.1,25.99,29.1,11.36,0,18.05-5.29,24.59-13.23l22.72,16.18c-10.27,14.16-24.12,24.59-48.09,24.59-31.12,0-56.18-23.81-56.18-56.33Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M134.62,120.03h30.19s0,40.77,0,40.77h38.75s0-40.77,0-40.77h30.19s0,108.93,0,108.93h-30.19s0-41.39,0-41.39h-38.75s0,41.39,0,41.39h-30.19s0-108.93,0-108.93Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M134.62,120.03h30.19s0,40.77,0,40.77h38.75s0-40.77,0-40.77h30.19s0,108.93,0,108.93h-30.19s0-41.39,0-41.39h-38.75s0,41.39,0,41.39h-30.19s0-108.93,0-108.93Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M363.06,212.78l16.81-20.07c10.89,8.56,22.72,13.07,35.32,13.07,8.25,0,12.61-2.8,12.61-7.47v-.31c0-4.67-3.58-7-18.52-10.58-23.19-5.29-41.08-11.83-41.08-34.08v-.31c0-20.23,16.03-34.86,42.17-34.86,18.52,0,32.99,4.98,44.82,14.47l-15.09,21.32c-9.96-7.16-20.85-10.74-30.5-10.74-7.31,0-10.89,2.96-10.89,7v.31c0,4.98,3.74,7.16,18.99,10.58,24.9,5.45,40.46,13.54,40.46,33.92v.31c0,22.25-17.58,35.48-44.04,35.48-19.3,0-37.5-6.07-51.04-18.05Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M450.46,155.16v-.08c0-7.52,6.09-13.85,13.77-13.85,7.76,0,13.77,6.25,13.77,13.77v.08c0,7.52-6.09,13.85-13.77,13.85-7.76,0-13.77-6.25-13.77-13.77ZM474.62,155.08v-.07c0-5.74-4.45-10.46-10.39-10.46-5.87,0-10.39,4.79-10.39,10.53v.07c0,5.74,4.45,10.46,10.39,10.46,5.87,0,10.39-4.79,10.39-10.53ZM458.97,148.6h6.01c3.24,0,5.4,1.42,5.4,4.25,0,1.96-.94,3.24-2.5,3.91l2.9,4.25h-4.39s-2.43-3.58-2.43-3.58h-1.15s0,3.58,0,3.58h-3.85v-12.42ZM464.77,154.54c1.15,0,1.75-.54,1.75-1.35,0-.88-.61-1.35-1.69-1.35h-2.02s0,2.7,0,2.7h1.96Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M241.36,228.96h31.59s7.78-19.61,7.78-19.61h42.17s7.78,19.61,7.78,19.61h32.37s-46.04-108.93-46.04-108.93h-29.76s-45.89,108.93-45.89,108.93ZM314.04,185.86h-24.43s12.29-30.81,12.29-30.81l12.14,30.81Z"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "cls-1",
  d: "M28.75,247.54h18.33c7.22,0,12.25.41,15.82,2.92,3.57,2.43,6,6.57,6,11.6,0,6.41-3.41,11.11-9.25,13.06v.08c7.14,1.62,11.03,6.65,11.03,13.79,0,9.41-6.65,16.23-18.74,16.23h-23.2v-57.68ZM48.22,272.45c8.84,0,12.9-3,12.9-9.25,0-6.98-5.03-9.17-12.66-9.17h-12.01v18.42h11.76ZM48.3,298.65c9.09,0,14.6-2.6,14.6-9.98,0-6.81-4.79-9.74-12.82-9.74h-13.63v19.71h11.85Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M87.81,282.75c0,12.82,5.44,17.36,14.44,17.36s14.03-4.95,14.03-17.36v-35.21h7.46v35.21c0,15.66-6.89,23.93-21.5,23.93s-21.91-7.38-21.91-23.93v-35.21h7.46v35.21Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M140.79,286.24c.08,9.49,6.41,13.79,15.33,13.79,7.63,0,14.12-3.08,14.12-10.14,0-6.49-4.62-8.03-15.82-10.87-13.95-3.57-19.8-6.98-19.8-16.39,0-10.71,9.25-16.47,20.69-16.47,12.41,0,20.77,6.25,21.26,18.5h-7.63c-.65-7.95-5.76-12.01-13.96-12.01-6.73,0-12.33,3.17-12.33,9.49s4.95,7.22,16.79,10.38c13.06,3.33,18.82,7.22,18.82,17.04,0,11.11-10.38,17.04-21.99,17.04-13.39,0-23.04-6.98-23.12-20.36h7.63Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M188.73,247.54h7.71v57.68h-7.71v-57.68Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M210.72,247.54h9.09l28.23,48.03.08-48.03h6.98v57.68h-9l-28.4-48.03v48.03h-6.98v-57.68Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M269.13,247.54h38.62v6.49h-30.91v18.33h28.72v6.41h-28.72v19.88h31.23v6.57h-38.94v-57.68Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M322.27,286.24c.08,9.49,6.41,13.79,15.33,13.79,7.63,0,14.12-3.08,14.12-10.14,0-6.49-4.62-8.03-15.82-10.87-13.95-3.57-19.8-6.98-19.8-16.39,0-10.71,9.25-16.47,20.69-16.47,12.41,0,20.77,6.25,21.26,18.5h-7.63c-.65-7.95-5.76-12.01-13.96-12.01-6.73,0-12.33,3.17-12.33,9.49s4.95,7.22,16.79,10.38c13.06,3.33,18.82,7.22,18.82,17.04,0,11.11-10.38,17.04-21.99,17.04-13.39,0-23.04-6.98-23.12-20.36h7.63Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M373.86,286.24c.08,9.49,6.41,13.79,15.33,13.79,7.63,0,14.12-3.08,14.12-10.14,0-6.49-4.62-8.03-15.82-10.87-13.95-3.57-19.8-6.98-19.8-16.39,0-10.71,9.25-16.47,20.69-16.47,12.41,0,20.77,6.25,21.26,18.5h-7.63c-.65-7.95-5.76-12.01-13.96-12.01-6.73,0-12.33,3.17-12.33,9.49s4.95,7.22,16.79,10.38c13.06,3.33,18.82,7.22,18.82,17.04,0,11.11-10.38,17.04-21.99,17.04-13.39,0-23.04-6.98-23.12-20.36h7.63Z"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "cls-1",
  d: "M32.5,361.78c.08,9.49,6.41,13.79,15.33,13.79,7.63,0,14.12-3.08,14.12-10.14,0-6.49-4.62-8.03-15.82-10.87-13.95-3.57-19.8-6.98-19.8-16.39,0-10.71,9.25-16.47,20.69-16.47,12.41,0,20.77,6.25,21.26,18.5h-7.63c-.65-7.95-5.76-12.01-13.96-12.01-6.73,0-12.33,3.17-12.33,9.49s4.95,7.22,16.79,10.38c13.06,3.33,18.82,7.22,18.82,17.04,0,11.11-10.38,17.04-21.99,17.04-13.39,0-23.04-6.98-23.12-20.36h7.63Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M80.37,323.08h7.79v24.83h28.31v-24.83h7.71v57.68h-7.71v-26.45h-28.31v26.45h-7.79v-57.68Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M138.21,323.08h7.71v57.68h-7.71v-57.68Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M160.19,323.08h38.62v6.49h-30.91v18.33h28.72v6.41h-28.72v19.88h31.23v6.57h-38.94v-57.68Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M209.6,323.08h7.71v51.11h29.05v6.57h-36.75v-57.68Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M254.95,323.08h15.33c19.55,0,30.02,9.09,30.02,28.23,0,18.01-9,29.45-28.4,29.45h-16.95v-57.68ZM271.5,374.19c10.38,0,20.77-4.71,20.77-22.55-.32-17.12-7.63-22.07-24.26-22.07h-5.35v44.62h8.84Z"
}));

var SvgChasBusinessShieldLogo = function SvgChasBusinessShieldLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 180,
    height: 150,
    style: {
      backgroundColor: "#603880"
    },
    viewBox: "0 0 500 500",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChasBusinessShieldLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chas-business-shield-logo.5c25b7d9.svg";
export { ForwardRef as ReactComponent };